import React from 'react';
import {
  CheckboxButton as AriaCheckboxButton,
  CheckboxField as AriaCheckboxField,
  CheckboxFieldProps as AriaCheckboxFieldProps,
} from 'react-aria-components';

import { createBEMClasses } from '@/utils/classname';

import './Checkbox.css';

const { block, element } = createBEMClasses('checkbox');

interface CheckboxProps extends AriaCheckboxFieldProps {
  variant?: 'default' | 'brand';
  align?: 'left' | 'right';
  isSelected?: boolean;
  isIndeterminate?: boolean;
  isDisabled?: boolean;
  children?: React.ReactNode;
  className?: string;
}

const Checkbox = ({
  variant = 'default',
  align = 'left',
  children,
  className,
  ...props
}: CheckboxProps) => (
  <AriaCheckboxField
    {...props}
    className={block(
      {
        variant,
        align,
      },
      className
    )}
  >
    <AriaCheckboxButton className={element('content')}>
      {({ isIndeterminate }) => (
        <>
          <div className={element('box')}>
            <svg viewBox="0 0 18 18" aria-hidden="true">
              {isIndeterminate ? (
                <rect x={1} y={7.5} width={15} height={3} />
              ) : (
                <polyline points="1 9 7 14 15 4" />
              )}
            </svg>
          </div>
          {children}
        </>
      )}
    </AriaCheckboxButton>
  </AriaCheckboxField>
);

export default Checkbox;
